import { render } from "./AttachmentModal.vue?vue&type=template&id=8e6cf76c"
import script from "./AttachmentModal.vue?vue&type=script&lang=js"
export * from "./AttachmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AttachmentModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8e6cf76c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8e6cf76c', __exports__)) {
    api.reload('8e6cf76c', __exports__)
  }
  
  module.hot.accept("./AttachmentModal.vue?vue&type=template&id=8e6cf76c", () => {
    api.rerender('8e6cf76c', render)
  })

}


export default __exports__